function SimpleInputController () {
  var ctrl = this

  ctrl.$onInit = function () {
    this.value = this.field.value || ''
    if (this.field.rules) {
      this.field.maxlength = parseInt(this.field.rules.filter(function (rule) { return rule.type === 'MAX_LENGTH' }).map(function (rule) { return rule.value })[0]) || undefined
    }
  }

  ctrl.changeValue = function () {
    if (this.field.maxlength && this.field.maxlength > 0 && this.value.length > this.field.maxlength) {
      this.value = this.value.substring(0, this.field.maxlength)
    }
    this.onChange({ value: this.value })
  }

  ctrl.$onChanges = ctrl.$onInit
}

export { SimpleInputController }
